module.exports = __webpack_public_path__ + "img/Example.b195db4b.png";